import { render, staticRenderFns } from "./TabButton.vue?vue&type=template&id=cf6e3888"
import script from "./TabButton.vue?vue&type=script&lang=js"
export * from "./TabButton.vue?vue&type=script&lang=js"
import style0 from "./TabButton.vue?vue&type=style&index=0&id=cf6e3888&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports